import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { fireFireworks, playCelebration } from "@/lib/confetti";

export default function LevelUpCelebration({ level, soundOn = true, onClose }) {
  useEffect(() => {
    if (!level) return;
    fireFireworks();
    if (soundOn) playCelebration();
    const t = setTimeout(onClose, 8000);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [level]);
  if (!level) return null;
  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 z-[90] grid place-items-center cursor-pointer"
        style={{ background: "rgba(6,15,20,0.9)", backdropFilter: "blur(6px)" }}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        onClick={onClose} data-testid="level-up-celebration">
        <div className="text-center px-6">
          <motion.div initial={{ scale: 0, rotate: -40 }} animate={{ scale: 1, rotate: 0 }}
            transition={{ type: "spring", stiffness: 190, damping: 13, delay: 0.15 }}
            className="mx-auto mb-5 grid place-items-center rounded-full relative"
            style={{ width: 148, height: 148, background: `radial-gradient(circle at 35% 28%, rgba(255,255,255,0.45), transparent 55%), ${level.color}`, boxShadow: `0 0 90px ${level.color}` }}>
            <motion.span className="absolute inset-0 rounded-full border-4"
              style={{ borderColor: level.color }}
              animate={{ scale: [1, 1.45], opacity: [0.8, 0] }}
              transition={{ duration: 1.4, repeat: Infinity, delay: 0.5 }} />
            <span className="font-display font-extrabold text-white" style={{ fontSize: 64, textShadow: "0 4px 18px rgba(0,0,0,0.35)" }}>
              {level.title === "Self-Agent" ? "★" : level.title[0]}
            </span>
          </motion.div>
          <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }}>
            <div className="font-display font-extrabold text-base tracking-[0.35em] uppercase" style={{ color: "#CCFF00" }}>Level up!</div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-1" style={{ color: "#FFFFFF", textShadow: "0 2px 20px rgba(0,0,0,0.6)" }} data-testid="level-up-title">{level.title}</h2>
            <p className="mt-3 max-w-sm mx-auto text-sm sm:text-base" style={{ color: "#C9D4DA" }}>
              {level.next
                ? `${level.min.toLocaleString()}+ lifetime coins earned. Next stop: ${level.next.title} at ${level.next.min.toLocaleString()}.`
                : "The highest rank there is. You own your path now."}
            </p>
            <button className="btn-primary mt-6 px-6 py-2.5" onClick={onClose} data-testid="level-up-continue">Keep going →</button>
          </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
